import {Pipe, PipeTransform} from '@angular/core';
import {FormatEuroCentsDirective} from "../directives/format-euro-cents.directive";

@Pipe({
    name: 'euroFormat',
    standalone: false
})
export class EuroFormatPipe implements PipeTransform {
    /**
     * Takes a value and formats into euros.
     */
    transform(value?: number, locale = 'nl') {
        if (!value) {
            return '';
        }
        return FormatEuroCentsDirective.convertNumberToEuros(value, locale);
    }
}
